export interface OrderItemLabels {
  itemDescription: string
  totalPrice: string
  poNote: string
  price: string
  quantity: string
  sku: string
  unit: string
  [key: string]: string
}

export interface POLabels {
  poNumber: string
  purchaseOrder: string
  shipTo: string
  comment: string
  creditcard: string
  date: string
  discount: string
  freight: string
  other: string
  paymentTerms: string
  prefVendor: string
  promiseDate: string
  shippingMethod: string
  shippingTerms: string
  subtotal: string
  tax: string
  total: string
  [key: string]: string
}

export interface PDFLabelSetConstructor {
  isPrimary: boolean
  key: string
  value: {
    name: string
    orderitem: OrderItemLabels
    po: POLabels
  }
}

export class PDFLabelSet {
  readonly isPrimary: boolean
  readonly key: string
  readonly value: {
    name: string
    orderitem: OrderItemLabels
    po: POLabels
  }

  constructor(data: PDFLabelSetConstructor) {
    this.isPrimary = data.isPrimary
    this.key = data.key
    this.value = data.value
  }
}
